import React, { Component, useState } from 'react';
import { MemoryRouter,Switch,Route,Redirect,withRouter} from "react-router-dom";
import {TabBar, Label} from 'app/components/Basics';
import './QuestionComponent.scss';
import GlobalControlLine from './components/GlobalControlLine/GlobalControlLineComponent';
import GlobalFieldLine from './components/GlobalFieldLine/GlobalFieldLineComponent';
import TabQuestion from './components/TabQuestion/TabQuestionComponent';
import {TabOptions} from './components/TabOptions/TabOptionsComponent';
import {TabInputText, TabInputNumeric} from './components/TabInput/TabInputComponent';
import TabScale from './components/TabScale/TabScaleComponent';
import TabRating from './components/TabRating/TabRatingComponent';
import TabLoop from './components/TabLoop/TabLoopComponent';
import {TabPresentationSelect, TabPresentationNumeric} from './components/TabPresentation/TabPresentationComponent';
import TabGrid from './components/TabGrid/TabGridComponent';
import {QuestionFormContext} from './QuestionContext'
import QuestionService from "../../services/question.service";
import  GetErrorMessage  from '../../helpers/error-message'
import {ShowError, ShowSuccess} from "../../components/toast"
import NewQuestion from './QuestionModel';
import NewQuestionTexts from './QuestionTextsModel';
import Modal from '../../components/Modal';
import cloneDeep from 'lodash/cloneDeep';
import isEqual from 'lodash/isEqual';
import ValidateQuestion from './QuestionValidation'
import { Constants } from '../../constants/constants'
import { GetLanguageTexts, addMissingLanguageTexts } from './QuestionTextHelper';
import { questionCategories } from '../../constants/question-categories'

class QuestionForm extends Component {
    tabs = [];
    constructor(props){
        super(props);
        this.state = {           
            activeTab:'question',
            selectedQuestion: NewQuestion(this.props.defaultLanguageCode),
            errors: [],
            selectedLanguageCode: this.props.defaultLanguageCode,
            selectedGridSubType: 'SS'
        }        
    }

    deriveGridSubType(selectedQuestion, fallbackSubType = 'SS') {
        if (!selectedQuestion || selectedQuestion.questionType !== 'GGROUP') {
            return fallbackSubType;
        }

        if (selectedQuestion.groupStatements && selectedQuestion.groupStatements.length > 0) {
            const typedGridQuestion = selectedQuestion.groupStatements.find(q => q.questionType && q.questionType !== 'GGROUP');
            if (typedGridQuestion) {
                return typedGridQuestion.questionType;
            }
        }

        return fallbackSubType;
    }

    getGridSubType(selectedQuestion = this.props.selectedQuestion) {
        return this.deriveGridSubType(selectedQuestion, this.state.selectedGridSubType || 'SS');
    }

    getActiveQuestionType(selectedQuestion = this.props.selectedQuestion) {
        if (!selectedQuestion) {
            return 'SS';
        }

        if (selectedQuestion.questionType !== 'GGROUP') {
            return selectedQuestion.questionType;
        }

        return this.getGridSubType(selectedQuestion);
    }

    changeGridSubType(gridSubType) {
        const selectedQuestion = this.props.selectedQuestion;
        if (!selectedQuestion || selectedQuestion.questionType !== 'GGROUP') {
            this.setState({ selectedGridSubType: gridSubType });
            return;
        }

        this.setState({ selectedGridSubType: gridSubType, activeTab: 'question' });

        if (selectedQuestion.groupStatements && selectedQuestion.groupStatements.length > 0) {
            selectedQuestion.groupStatements.forEach(gridQuestion => {
                gridQuestion.questionType = gridSubType;
            });
            this.props.updateSelectedQuestion(selectedQuestion);
        }
    }

    getTabs(selectedQuestion) {
        const activeQuestionType = this.getActiveQuestionType(selectedQuestion);
        const isGridQuestion = selectedQuestion.questionType === 'GGROUP';

        return [
            { id:"question", label: 'Question', url: 'question', disabled:false, error:this.tabQuestionHasValidationError()},
            { id:"options", label: 'Options', url: 'options', disabled: this.isOptionTabDisabled(selectedQuestion, activeQuestionType), error:this.tabOptionHasValidationError()},
            { id:"input", label: 'Input', url: 'input', disabled:!(activeQuestionType==="OPEN")},
			{ id:"inputNumeric", label: 'Input', url: 'inputNumeric', disabled:!(activeQuestionType==="NUMERIC"), error:this.tabInputNumericHasValidationError()},
			{ id:"rating", label: 'Rating', url: 'rating', disabled:!(activeQuestionType==="RATING"), error:this.tabInputNumericHasValidationError()},
            { id:"scale", label: 'Scale', url: 'scale', disabled:!(activeQuestionType==="SCALE")},
            { id:"grid", label: 'Statements', url: 'grid', disabled:!isGridQuestion, error:this.tabGridHasValidationError()},			
            { id:"presentation", label: 'Presentation', url:'presentation', disabled: this.isPresentationTabDisabled(selectedQuestion, activeQuestionType)},
			{ id:"presentationNumeric", label: 'Presentation', url:'presentationNumeric', disabled: !(activeQuestionType==="NUMERIC"), error:this.tabInputNumericPresentationHasValidationError()},			
            { id:"loop", label: 'Loop', url: 'loop', disabled:true}
        ];
    }

    isOptionTabDisabled(selectedQuestion, activeQuestionType) {
        if (!selectedQuestion) return false;
        return activeQuestionType === "OPEN" 
		|| activeQuestionType === "NUMERIC"
		|| activeQuestionType === "RATING"
        || activeQuestionType === "INTRO";
    }

    isPresentationTabDisabled(selectedQuestion, activeQuestionType) {		
        if (!selectedQuestion) return true;
        return activeQuestionType.endsWith("OPEN") 
		|| activeQuestionType === "NUMERIC"
        || activeQuestionType === "INTRO"
        || selectedQuestion.isSys !== questionCategories.Default;        
    }

    componentWillReceiveProps(nextProps) {
		if (nextProps.selectedQuestion != null && this.props.selectedQuestion != null) {
            if (nextProps.selectedQuestion.id !== this.props.selectedQuestion.id) {
			    this.setState({ 
                    activeTab: "question",
                    selectedLanguageCode: this.props.defaultLanguageCode,
                    selectedGridSubType: this.deriveGridSubType(nextProps.selectedQuestion, 'SS')
                });
            }
		}

        if (!isEqual(this.props.selectedQuestion, nextProps.selectedQuestion)) {
            this.setState({errors: []});            
        }
    }

    updateSelectedQuestion(newSelectedQuestion) {        
        this.props.updateSelectedQuestion(newSelectedQuestion);
    }

	getUpdatedQuestion(questionId) {
		this.props.toggleUiBlock(true);
		QuestionService.getQuestionById(questionId)
			.then(response => {				
				const updatedQuestion = response.data;
				addMissingLanguageTexts(updatedQuestion, this.state.selectedLanguageCode, () => {});
				this.props.updateSavedQuestionOnList(updatedQuestion);
                this.props.updateSelectedQuestion(updatedQuestion);
				this.props.toggleUiBlock(false);
			})
			.catch(error => {
                let errorMessage = GetErrorMessage(error);
                console.log("errorMessage on catch");
                console.log(errorMessage);
                this.props.toggleUiBlock(false);
                this.setState({ errorMessage: errorMessage});
            });       
	}

    saveQuestion(question) {
        this.props.toggleUiBlock(true);
        if (question.id) {
            QuestionService.UpdateQuestion(question)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The question was saved successfully' });
					this.getUpdatedQuestion(question.id);                    
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }
        else {            
            QuestionService.CreateQuestion(question)
                .then(response => {                    
                    const newQuestion = response.data;                    
                    this.props.toggleUiBlock(false);
                    this.setState({successMessage: 'The question was created successfully' });                    
                    this.props.updateSavedQuestionOnList(newQuestion);                    
                    this.props.updateSelectedQuestion(newQuestion);
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
        }

    }
    
	deleteQuestion = event => {   
		if (this.props.canChangeData) {     
        	this.setState({ deleteQuestionModalText: `Are you sure you want to delete the question with code '${this.props.selectedQuestion.code}'?`});
		}
    }

    duplicateQuestion = event => {        
        let clonedQuestion = cloneDeep(this.props.selectedQuestion);
        clonedQuestion.id = null;
		clonedQuestion._frontEndQuestionId = null;
        clonedQuestion.code = `${clonedQuestion.code}_copy`;
		if (clonedQuestion.groupStatements != null) {
			for (let index = 0; index < clonedQuestion.groupStatements.length; index++) {				
				let gridQuestion = clonedQuestion.groupStatements[index];
				gridQuestion.id = null;
				gridQuestion._frontEndQuestionId = Constants.TEMP_ID_PLACEHOLDER + Date.now() + "_" + index;				
				gridQuestion.code = `${gridQuestion.code}_copy`;
			}
		}        
		this.props.updateSelectedQuestion(clonedQuestion);
    }

    confirmDelete() {        
        this.hideDeleteModal();
        this.props.toggleUiBlock(true);
        const questionId = this.props.selectedQuestion.id;
        QuestionService.DeleteQuestion(this.props.selectedQuestion)
        .then(response =>{
            this.props.toggleUiBlock(false);
            this.setState({successMessage: 'The question was deleted successfully' });            
            this.props.removeDeletedQuestion(questionId);            
            this.props.closeEditor();
        })
        .catch(error => {
            let errorMessage = GetErrorMessage(error);
            console.log("errorMessage on catch");
            console.log(errorMessage);
            this.props.toggleUiBlock(false);
            this.setState({ errorMessage: errorMessage});
        });
    }

    hideDeleteModal() {
        this.setState({deleteQuestionModalText: ''})
    }

    questionTypeChange() {
        this.setState({ activeTab: "question"});
    }	

	tabOptionHasValidationError() {		
		let validationError = this.state.errors.find(e => e.field.startsWith('option'));
		return validationError != null ? true : false;
	}

	tabQuestionHasValidationError() {		
		let validationError = this.state.errors.find(e => e.field === 'text');
		return validationError != null ? true : false;
	}

	tabInputNumericHasValidationError() {
		if (this.tabOptionHasValidationError()) return true;
		let validationError = this.state.errors.find(e => e.field.startsWith('numeric'));		
		return validationError != null ? true : false;
	}

	tabInputNumericPresentationHasValidationError() {		
		let validationError = this.state.errors.find(e => e.field.startsWith('scale'));		
		return validationError != null ? true : false;
	}
	
	tabGridHasValidationError() {		
		let validationError = this.state.errors.find(e => e.field.startsWith('gridQuestion'));
		return validationError != null ? true : false;
	}

    syncGridStatementFields() {		
		let selectedQuestion = this.props.selectedQuestion;
        const gridSubType = this.getGridSubType(selectedQuestion);
		var gridOptions = cloneDeep(selectedQuestion.options);
		selectedQuestion.groupStatements.forEach(gridQuestion => {
			gridQuestion.options = gridOptions;
            gridQuestion.questionType = gridSubType;
            gridQuestion.layoutType = selectedQuestion.layoutType;
            gridQuestion.isSys = selectedQuestion.isSys;
            gridQuestion.openColumns = selectedQuestion.openColumns;
            gridQuestion.openRows = selectedQuestion.openRows;
            gridQuestion.openMax = selectedQuestion.openMax;
            gridQuestion.openOptional = selectedQuestion.openOptional;
            gridQuestion.numericMin = selectedQuestion.numericMin;
            gridQuestion.numericMax = selectedQuestion.numericMax;
            gridQuestion.numericDecimalMax = selectedQuestion.numericDecimalMax;
            gridQuestion.multiSelectMax = selectedQuestion.multiSelectMax;
            gridQuestion.folderId = selectedQuestion.folderId;
            gridQuestion.isHidden = selectedQuestion.isHidden;
            this.syncGridStatementTranslationFields(selectedQuestion, gridQuestion);
		});
		this.props.updateSelectedQuestion(selectedQuestion);
	}

    syncGridStatementTranslationFields(parentQuestion, gridQuestion) {
        if (!gridQuestion.texts) {
            gridQuestion.texts = [];
        }

        parentQuestion.texts.forEach(parentText => {
            if (!parentText || !parentText.languageCode) {
                return;
            }

            let gridText = gridQuestion.texts.find(t => t.languageCode === parentText.languageCode);
            if (!gridText) {
                gridText = NewQuestionTexts(parentText.languageCode);
                gridQuestion.texts.push(gridText);
            }

            gridText.openOptional = parentText.openOptional;
            gridText.scaleMinLabel = parentText.scaleMinLabel;
            gridText.scaleMaxLabel = parentText.scaleMaxLabel;
            gridText.numericSuffix = parentText.numericSuffix;
        });
    }

    handleSubmitAction = event => {
		if (this.props.canChangeData) {
			this.setState({errors: []});        

			if (this.formEl.checkValidity()) {            
				try {
					var validationErrors = ValidateQuestion(this.props.selectedQuestion, this.props.defaultLanguageCode);
					this.setState({errors: validationErrors});

					if (validationErrors && validationErrors.length === 0) {
						if (this.props.selectedQuestion.questionType === "GGROUP") {
                            this.syncGridStatementFields();
						}
						// Apply group Fixed mode overrides: set all options to isFixed=1 for groups in Fixed mode
						if (this.props.selectedQuestion._groupFixedModes) {
							for (const [group, mode] of Object.entries(this.props.selectedQuestion._groupFixedModes)) {
								if (mode === 'fixed') {
									this.props.selectedQuestion.options
										.filter(o => (o.groupSortOrder ?? 0) === parseInt(group))
										.forEach(o => { o.isFixed = 1; });
								}
							}
							delete this.props.selectedQuestion._groupFixedModes;
						}
						this.saveQuestion(this.props.selectedQuestion);
					}
					
				} catch (e) {
					console.log("catch form validation");
					console.log(e);
				}

				event.preventDefault();
			}
		}
    }

    setSelectedLanguage(languageCode) {
        this.setState({selectedLanguageCode: languageCode});
        addMissingLanguageTexts(this.props.selectedQuestion, languageCode, this.props.updateSelectedQuestion);
    }    

    componentDidUpdate(prevProps, prevState) {
        addMissingLanguageTexts(this.props.selectedQuestion, this.state.selectedLanguageCode, this.props.updateSelectedQuestion);

        const derivedGridSubType = this.deriveGridSubType(this.props.selectedQuestion, this.state.selectedGridSubType || 'SS');
        if (this.state.selectedGridSubType !== derivedGridSubType) {
            this.setState({ selectedGridSubType: derivedGridSubType });
        }
    }
    
    archiveQuestion = event => {
        var newArhiveValue = this.state.selectedQuestion.inArchive === 1 ? 0 : 1
        QuestionService.ArchiveQuestion(this.state.selectedQuestion.id, newArhiveValue)
                .then(response =>{                    
                    this.props.toggleUiBlock(false);
                    var msg = newArhiveValue === 1 ? "archived" : "unarchived";                    
                    this.setState({successMessage: `The question was ${msg} successfully` });
					this.getUpdatedQuestion(this.state.selectedQuestion.id);                    
                })
                .catch(error => {
					let errorMessage = GetErrorMessage(error);
					console.log("errorMessage on catch");
					console.log(errorMessage);
					this.props.toggleUiBlock(false);
					this.setState({ errorMessage: errorMessage});
                });
    }

    addNextOptionValue(options, newValue) {
        if (options && options.length > 0) {        
            newValue = this.getMaxOptionValue(options);            
            newValue = newValue + 1;
        }
        var questionOption = {
            value: newValue,
            text: "",
            texts: []
        }
        var selectedQuestion = this.props.selectedQuestion;
        selectedQuestion.options.push(questionOption);        
        this.props.updateSelectedQuestion(selectedQuestion);
    }

    getMaxOptionValue(options) {
        return Math.max.apply(Math, options.map(function(o) { return o.value; }));
    }

    render() {
        if (this.props.selectedQuestion == null) {
            return null;
        }

        this.tabs = this.getTabs(this.props.selectedQuestion);
    const activeQuestionType = this.getActiveQuestionType(this.props.selectedQuestion);
        return (        
               
            <div className="AppFormComponent QuestionForm">
                <QuestionFormContext.Provider value={{updateSelectedQuestion: this.props.updateSelectedQuestion.bind(this), 
					selectedQuestion: this.props.selectedQuestion,
					canChangeData: this.props.canChangeData,
                    canChangeDemoQuestion: this.props.canChangeDemoQuestion,
                    canChangeHoneypotQuestion: this.props.canChangeHoneypotQuestion,					
                    toggleUiBlock: this.props.toggleUiBlock,                    
                    selectedLanguageCode: this.state.selectedLanguageCode,
                    defaultLanguageCode: this.props.defaultLanguageCode,
					gridSubType: this.getGridSubType(this.props.selectedQuestion)}}>
                    <form ref={ form => this.formEl = form } onSubmit={ this.handleSubmitAction }>
						
                        <GlobalControlLine errors={this.state.errors} 
                            handleSubmitAction={this.handleSubmitAction.bind(this)} 
                            deleteQuestion={this.deleteQuestion.bind(this)}
                            duplicateQuestion={this.duplicateQuestion.bind(this)}
                            closeEditorButtonOnClick={this.props.closeEditorButtonOnClick}
                            didSelectedQuestionChange={this.props.didSelectedQuestionChange}
                            defaultLanguageCode={this.props.defaultLanguageCode}
                            archiveQuestion={this.archiveQuestion.bind(this)}/>

                        <div className="form-head">                            
                            <GlobalFieldLine questionTypeChange={this.questionTypeChange.bind(this)} 
                                folders={this.props.folders}
                                setSelectedLanguage={this.setSelectedLanguage.bind(this)}
                                languages={this.props.languages}
								gridSubType={this.getGridSubType(this.props.selectedQuestion)}
								changeGridSubType={this.changeGridSubType.bind(this)}/>
                            {this.state.selectedQuestion.inArchive === 1 && (<div><Label>This question is archived!</Label></div>)}
                        </div>
                        <div className="form-sections">
                            <MemoryRouter>
                                <div className="tab-bar">
                                    <TabBar key="QuestionForm" activeTab={this.state.activeTab} tabs={this.tabs} onTabActivate={item=>this.setState({activeTab:item.id})}/>
                                    {/* <div title="Load the current tab settings from another question." className="duplicate-tab"><ButtonIcon icon={DuplicateIcon}/></div> */}
                                </div>
                                <div className="section-content" key={this.state.selectedLanguageCode}>
                                    <Switch>
                                        <Route exact path="/"><Redirect to={this.state.activeTab}/></Route>
                                        <Route exact path="/question"><TabQuestion errors={this.state.errors} /></Route>
										<Route exact path="/options"><TabOptions addNextOptionValue={this.addNextOptionValue.bind(this)} errors={this.state.errors} isMulti={activeQuestionType ==="MS" || activeQuestionType ==="MSOPEN"}/></Route>
                                        <Route exact path="/inputNumeric"><TabInputNumeric addNextOptionValue={this.addNextOptionValue.bind(this)} errors={this.state.errors}/></Route>
										<Route exact path="/presentationNumeric"><TabPresentationNumeric errors={this.state.errors}/></Route>										
                                        <Route exact path="/input"><TabInputText/></Route>
										<Route exact path="/rating"><TabRating/></Route>
                                        <Route exact path="/scale" component={TabScale}/>
										<Route exact path="/grid"><TabGrid hasError={this.tabGridHasValidationError()} errors={this.state.errors} /></Route>
										<Route exact path="/loop" component={TabLoop}/>
                                        {/* <Route exact path="/presentation">
                                            {this.state.qType==="SINGLE" || this.state.qType==="MULTI" ? <TabPresentationSelect/> : 
                                                this.state.qType==="SCALE" ? <TabPresentationRating/> : 
                                                this.state.qType==="NUMBER" ? <TabPresentationInput/> : ""
                                            }
                                        </Route> */}
                                        <Route exact path="/presentation"><TabPresentationSelect/></Route>
                                    </Switch>
                                    <Redirect to={this.state.activeTab}/>
                                </div>
                            </MemoryRouter>
                        </div>						
                    </form>                    
                </QuestionFormContext.Provider>

                {this.state.errorMessage && ( <ShowError clearErrorMessage={() => this.setState({errorMessage: ''})} errorMessage={this.state.errorMessage} /> )}
                {this.state.successMessage && ( <ShowSuccess clearMessage={() => this.setState({successMessage: ''})} message={this.state.successMessage} /> )}
                {this.state.deleteQuestionModalText && ( <Modal size="small" content={this.state.deleteQuestionModalText} confirmModalHandler={this.confirmDelete.bind(this)} cancelModalHandler={this.hideDeleteModal.bind(this)} />)}
            </div>            
        );
    }
}
export default withRouter(QuestionForm); 
